import { useSession } from '~/stores/session';

export function redirectUserIfNotAllowedCurrentPath() {
  redirectUserIfNotAllowed(window.location.pathname);
}

export function redirectUserIfNotAllowed(path: string) {
  const redirect = getRedirectUserIfNotAllowed(path);
  if (redirect) {
    navigateTo(redirect);
  }
}

export function logout() {
  navigateTo('/auth/logout');
}

function hasLicenseToViewRoute(route: string): boolean {
  const { canUseFeature } = useLicense();
  if (
    route.startsWith('/presentation') &&
    !canUseFeature(FeatureKey.PRESENTATION_MODE)
  ) {
    return false;
  }
  if (
    route.startsWith('/timetable/vacation') &&
    !canUseFeature(FeatureKey.CALENDAR_VACATION)
  ) {
    return false;
  }
  return true;
}

export async function getRedirectUserIfNotAllowed(
  path: string,
): string | undefined {
  const sessionStore = useSession();

  const publicUrls = [
    '/legal/imprint',
    '/legal/privacy',
    '/legal/terms',
    '/invite',
    '/c/',
    '/auth/integration/',
    '/auth/signup-from-website',
    '/auth/login-from-website',
    '/embed',
    '/student-ai/templates/public-preview',
    '/auth/refresh',
    '/help',
  ];
  if (publicUrls.find((item) => path.startsWith(item))) {
    return;
  }

  const publicOnlyUrls = [
    '/auth/login',
    '/auth/signup-teacher',
    '/auth/reset-password',
  ];
  const pathToEmailVerification = '/auth/signup-verify-email';
  const blockedUrls = [pathToEmailVerification];
  if (!sessionStore.isLoggedIn) {
    // user who is not logged in and tries to access protected url
    if (!publicOnlyUrls.find((item) => path.startsWith(item))) {
      console.log(path);

      return '/auth/login';
    }
  } else if (path == '/auth/logout') {
    //always let the user log out
    return;
  } else if (sessionStore.needsEmailVerification) {
    // email is not verified -> redirect to email verification
    if (!path.includes(pathToEmailVerification)) {
      return pathToEmailVerification;
    }
  } else {
    const combinedUrlList = [...publicOnlyUrls, ...blockedUrls];
    for (const url of combinedUrlList) {
      if (path.includes(url)) {
        return '/';
      }
    }
    const { loadUserIfNeeded } = useCurrentUser();
    await loadUserIfNeeded();
    if (!hasLicenseToViewRoute(path)) {
      return '/account/discoverpro';
    }
  }
}

export default defineNuxtRouteMiddleware(async (to) => {
  const redirect = await getRedirectUserIfNotAllowed(to.fullPath);
  if (redirect) {
    return navigateTo(redirect);
  }
});
